var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,23.55c-4.17,0-7.55,3.38-7.55,7.55s3.38,7.55,7.55,7.55,7.55-3.38,7.55-7.55-3.38-7.55-7.55-7.55ZM34.89,31.1c0-8.34,6.77-15.11,15.11-15.11s15.11,6.77,15.11,15.11-6.77,15.11-15.11,15.11-15.11-6.77-15.11-15.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,84c2.09,0,3.78-1.69,3.78-3.78v-13.22c0-4.17,3.38-7.55,7.55-7.55h22.66c4.17,0,7.55,3.38,7.55,7.55v13.22c0,2.09,1.69,3.78,3.78,3.78s3.78-1.69,3.78-3.78v-13.22c0-8.34-6.77-15.11-15.11-15.11h-22.66c-8.34,0-15.11,6.77-15.11,15.11v13.22c0,2.09,1.69,3.78,3.78,3.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeUser);
export default __webpack_public_path__ + "static/media/acae_user.49829f5b.svg";
export { ForwardRef as ReactComponent };